import { jsxs as l, jsx as o } from "react/jsx-runtime";
import { useState as g, useEffect as k } from "react";
import { useTranslation as z } from "react-i18next";
import v from "../../../components/Button/index.js";
import w from "../../../components/ProgressBar/index.js";
import C from "../../../icons/Trash.js";
import y from "../../../icons/Upload.js";
import _ from "../../../data/mock.js";
const M = "forma-ui__file-dropzone-files-list__files", B = "forma-ui__file-dropzone-files-list__file", $ = "forma-ui__file-dropzone-files-list__fileIcon", j = "forma-ui__file-dropzone-files-list__fileInfo", q = "forma-ui__file-dropzone-files-list__fileText", A = "forma-ui__file-dropzone-files-list__fileName", D = "forma-ui__file-dropzone-files-list__fileSize", E = "forma-ui__file-dropzone-files-list__remove", L = "forma-ui__file-dropzone-files-list__removeIcon", P = "forma-ui__file-dropzone-files-list__buttons", V = "forma-ui__file-dropzone-files-list__button", K = "forma-ui__file-dropzone-files-list__buttonIcon", e = {
  files: M,
  file: B,
  fileIcon: $,
  fileInfo: j,
  fileText: q,
  fileName: A,
  fileSize: D,
  remove: E,
  removeIcon: L,
  buttons: P,
  button: V,
  buttonIcon: K
}, O = ({ file: t, onRemove: n }) => {
  const { t: r } = z(), [f, a] = g(0), { name: i, path: s, size: c } = t, u = i.lastIndexOf("."), h = i.slice(0, u), m = i.slice(u).toLowerCase();
  return k(() => {
    let d = 0;
    const N = 100, b = 1e3, x = performance.now(), p = (T) => {
      const F = T - x, I = Math.min(F / b, 1), S = Math.floor(I * (N - d) + d);
      a(S), I < 1 && requestAnimationFrame(p);
    };
    requestAnimationFrame(p);
  }, []), /* @__PURE__ */ l("div", { className: e.file, children: [
    /* @__PURE__ */ o("img", { src: _.filesIcons[m] ? _.filesIcons[m] : _.filesIcons.other, className: e.fileIcon, alt: m }),
    /* @__PURE__ */ l("div", { className: e.fileInfo, children: [
      /* @__PURE__ */ l("div", { className: e.fileText, children: [
        /* @__PURE__ */ o("div", { className: e.fileName, children: h }),
        /* @__PURE__ */ o("span", { className: e.fileSize, children: c / 1024 >= 1024 ? `${(c / 1024 / 1024).toFixed(2)}MB` : `${Math.ceil(c / 1024)}Kb` })
      ] }),
      /* @__PURE__ */ o(w, { value: f, max: 100 })
    ] }),
    /* @__PURE__ */ o(
      v,
      {
        className: e.remove,
        viewStyle: "text",
        iconClassName: e.removeIcon,
        icon: /* @__PURE__ */ o(C, {}),
        onClick: n,
        title: r("uikit:delete")
      }
    )
  ] }, s);
}, Y = ({ files: t, maxFiles: n, onRemove: r, onClickAdd: f }) => {
  const { t: a } = z();
  return /* @__PURE__ */ l("div", { className: e.files, children: [
    t.map((i, s) => /* @__PURE__ */ o(O, { file: i, onRemove: () => r(s) }, s)),
    /* @__PURE__ */ o("div", { className: e.buttons, children: /* @__PURE__ */ o(
      v,
      {
        viewStyle: "secondary",
        className: e.button,
        size: "small",
        onClick: (i) => {
          i.stopPropagation(), f();
        },
        icon: /* @__PURE__ */ o(y, {}),
        iconClassName: e.buttonIcon,
        disabled: t.length >= n,
        reversed: !0,
        children: a("uikit:upload_more")
      }
    ) })
  ] });
};
export {
  Y as default
};
